import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEscrowReconciliation extends Layout {
    checkboxIncludeAdjustments: Checkbox;
    excludabletextboxGLAccounts: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    sourceEscrowReconciliation: DataSource;
    textboxDate: Textbox;
}
